<style>
    .ivu-table .demo-table-settled-row td{
        color: #19be6b;
    }

    .ivu-table .demo-table-disc-row td{
        color: #c30e0e;
    }

    .ivu-table .demo-table-claim-row td{
        color: #2db7f5;
    }

    .ivu-table .demo-table-claim-depo-row td{
        color: #c32df5;
    }

    .ivu-table .demo-table-giro-row td{
        color: #de2df5;
    }
</style>

<template>
    <div>

        <Card>
            <p slot="title">
                Kartu Piutang Detail
            </p>
            <Row type="flex" justify="space-between" class="code-row-bg">
                <Col span="6">
                    <Select
                        style="width: 250px;"
                        placeholder="Ketik Marking"
                        v-model="markingIdSelected"
                        filterable
                        clearable
                        remote
                        :remote-method="getMarkingByCode"
                        :loading="loadingGetMarking"
                        @on-change="getReceivableData()" >
                        <Option v-for="option in optionMarkings"
                            :value="option.value" :key="new Date()">{{option.label}}</Option>
                    </Select>

                </Col>
                <Col span="6">
                    <Spin size="large" v-show="loadingGetReceivable"></Spin>
                </Col>
                <Col span="6">
                </Col>
            </Row>

            <br>

            <Card
                v-show="receivables.length > 0">
                <p slot="title">
                </p>
                <template slot="extra">
                    <Button v-show="canCreateReceivable()"
                        type="success"
                        @click="modal.createReceivable=true"
                        icon="plus-round"
                        size="small"  >
                            Tambah Piutang
                    </Button>
                </template>

                <div
                    v-show="depositRemaining > 0">
                    <Alert type="warning" show-icon>Deposit = {{ depositRemaining | currency }}</Alert>
                    <Alert show-icon>Balance - Deposit = {{ (countBalance - depositRemaining) | currency }}</Alert>
                </div>

                <Table
                    :row-class-name="rowClassName"
                    :columns="tableColumns"
                    :data="receivables"

                    no-data-text=""
                ></Table>
            </Card>
        </Card>

        <Modal v-model="modal.createReceivable" width="500px"
            @on-cancel="clearCreateReceivable()">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Tambah Piutang</span>
            </p>

                <Form :label-width="120">
                    <Form-item label="Tgl Transaksi">
                        <Row>
                            <Col span="4">
                                <Date-picker v-model="createReceivable.transactionDate"
                                    style="width: 110px;"
                                    type="date"
                                    placeholder=""
                                    format="dd/MM/yyyy">
                                </Date-picker>

                            </Col>
                            <Col span="1">&nbsp;
                            </Col>
                        </Row>
                    </Form-item>
                    <Form-item label="Keterangan"
                        v-show="true">
                        <Input v-model="createReceivable.description"
                            style="width: 300px;" ></Input>
                    </Form-item>
                    <Form-item label="Jumlah"
                        v-show="true">
                        <money
                            v-model="createReceivable.amount"
                            v-bind="money"
                            class="ivu-input right"
                            style="width: 150px;"></money>
                    </Form-item>
                    <Form-item label="Upload File" prop="file">
                        <br>
                        <Upload
                            type="drag"
                            ref="upload"
                            name="fileUploaded"
                            :action="this.serverUrlUploadFile"
                            :before-upload="handleBeforeUpload">
                            <div style="padding: 20px 0">
                                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                                <p>Click or drag files here to upload</p>
                            </div>
                        </Upload>
                        <Progress :percent="pValue" :stroke-width="20" v-show="isProgress" />
                    </Form-item>
                </Form>

            <div slot="footer">
                <Button
                    v-show="true"
                    type="primary"
                    :loading="loadingCreateReceivable"
                    @click="postCreateReceivable" >
                    <span v-if="!loadingCreateReceivable">Simpan</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
        </Modal>

    </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'
import {Money} from 'v-money'

const numeral = require('numeral');
var axios = require('axios');

export default {
    components : {Money},
    data: () => ({
        user : {
            username : '',
            role : ''
        },
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 0,
          masked: false
        },
        modal : {
            createReceivable : false
        } ,
        createReceivable : {
            transactionDate: '',
            description: '',
            amount: 0,
            filename: ''
        },
        loadingCreateReceivable : false,
        markingIdSelected : '',
        depositRemaining : Number, // untuk menampung total sisa deposit
        countBalance  : Number,
        optionMarkings : [],
        loadingGetMarking: false,
        loadingGetReceivable: false,
        markings : [],
        receivables : [],
        subbranchcode : localStorage.getItem('user.subbranchcode'),
        tableColumns: [
            {
                type: 'index',
                width: 80,
                align: 'center'
            },
            {
                title: 'Tgl',
                key: 'transactionDate',
                type: 'html',
                sortable: false
            },
            {
                title: 'Keterangan',
                key: 'description',
                width: 300,
                type: 'html',
                sortable: false
            },
            {
                title: 'Debet',
                key: 'debitAmount',
                align: 'right',
                sortable: false,
                cellClassName: {
                    name: 'demo-table-info-cell-name'
                }

            },
            {
                title: 'Kredit',
                key: 'creditAmount',
                align: 'right',
                sortable: false
            },
            {
                title: '+/- Deposit',
                key: 'depositAmount',
                align: 'right',
                sortable: false,
                cellClassName: {
                    name: 'demo-table-info-cell-name'
                }
            },
             {
                title: 'Balance - Deposit',
                key: 'balanceWithoutDeposit',
                align: 'right',
                sortable: false
            },
            {
                title: 'Balance',
                key: 'balance',
                align: 'right',
                sortable: false
            }
        ],
        filterInput : '',

        serverUrlUploadFile: '',
        isProgress: false,
        pValue: 0,
    }),

    methods: {
        clearCreateReceivable(){
            this.createReceivable.transactionDate = ''
            this.createReceivable.description = ''
            this.createReceivable.amount = 0
            this.createReceivable.filename = ''
        },
        canCreateReceivable () {
            let canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMIN', 'ADMIN-DEPOSIT', 'SUPERVISOR-SBY'], this.user.role);
            console.log('this.user.role = ' + this.user.role)
            console.log('canAccess = ' + canAccess)
            return canAccess;
        },
        handleBeforeUpload (file) {
            console.log({file});

            const formData = new FormData();
            formData.append('file', file);
            formData.append('marking', this.receivables[0].markingheadercode);

            this.isProgress = true;
            this.pValue = Math.floor(Math.random() * 100); // Returns a random integer from 0 to 99:

            HTTP
            .post('receivable/file/upload', formData, {
               headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
                this.createReceivable.filename = response.data.filename; // Set filename
                // this.isProgress = false;
                this.pValue = 100;
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc:e,
                    duration: 5
                });
            })

            return false; // Kembalikan false untuk mencegah unggahan otomatis
        },
        postCreateReceivable() {
            this.loadingCreateReceivable = true
            this.createReceivable.transactionDate = moment(this.createReceivable.transactionDate, 'YYYY-MM-DD').format("YYYY-MM-DD");

            let payload = {
                markingHeaderId: this.markingIdSelected,
                transactionDate: this.createReceivable.transactionDate,
                description: this.createReceivable.description,
                amount: this.createReceivable.amount,
                filename: this.createReceivable.filename,
            }

            console.log({payload});
            HTTP
            .post('receivable/debit/create', payload)
            .then(response => {
                this.clearCreateReceivable()

                this.loadingCreateReceivable = false
                this.modal.createReceivable = false
                this.getReceivableData()
            })
            .catch(e => {
                this.clearCreateReceivable()
                this.loadingCreateReceivable = false
                this.modal.createReceivable = false
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },
        rowClassName (row, index) {
            if (row.isSettled) {
                return 'demo-table-settled-row';
            }

            if (row.category == 'disc') {
                return 'demo-table-disc-row';
            }

            if (row.claimId) {
                return 'demo-table-claim-depo-row';
            }

            if (row.claim) {
                return 'demo-table-claim-row';
            }

            if (row.giro) {
                return 'demo-table-giro-row';
            }

            return '';
        },
        getReceivable: function(){
            if(this.markingIdSelected !== ''){
                return HTTP.get('receivable/show/' + this.markingIdSelected)
            } else {
                this.receivables = []
            }
        },
        getDepositRemaining: function(){
            if(this.markingIdSelected !== ''){
                return HTTP.get('deposit/remaining/' + this.markingIdSelected)
            } else {
                this.depositRemaining = 0;
            }
        },
        getReceivableData: function(){
            let parent = this;

            this.invoiceDues = []
            this.receivables = []
            this.amountResidue = ''
            this.amountReceived = ''
            this.description = ''
            this.depositRemaining = Number
            this.countBalance = Number

            if(this.markingIdSelected == ''){
                return;
            }

            this.loadingGetReceivable = true;
            axios.all([
                this.getReceivable(),
                this.getDepositRemaining()
            ]).then(axios.spread((receivableRes, depositRemainingRes) => {
                let receivables = []
                let countBalance = 0;
                let countBalanceWithoutDeposit = 0;

                _.forEach(receivableRes.data, function(value) {
                    let invoicefee = value.invoice != null ? value.invoice.invoicefee : 0;

                    let debitAmount = value.debitAmount;

                    let totalvolume = value.invoice != null ? value.invoice.totalvolume : 0;
                    let isSettled = parent.isSettled(value.invoice_due)

                    let description = value.description
                    if(value.invoice != null)
                    {
                        description += "<br/>( vol = " + numeral(totalvolume).format('0.000');

                        if(invoicefee != debitAmount){
                            description += ", inv = " + numeral(invoicefee).format('0,0')
                        }
                        description += " )"
                    }

                    //Faisal 12 Januari : Deposit dari Klaim tidak mempengaruhi perhitungan balance
                    if((value.type == 'DEP' && value.claimId != null) || value.isCalculated == 0 || description.includes('Penarikan')) {

                    } else {
                      let subBalance = (debitAmount - value.creditAmount)
                      countBalance = (countBalance + subBalance)
                    }

                     if((value.type == 'DEP' && value.claimId != null) || value.isCalculated == 0 || description.includes('Penarikan')) {

                    } else {
                      if (value.type != 'DEP') {
                        let subBalance = (debitAmount - value.creditAmount)
                        countBalanceWithoutDeposit = (countBalanceWithoutDeposit + subBalance)
                      }
                    }


                    let arrayDescriptionContainer = '';
                    let arrayClaimDetail = '';
                    let isCategory = ''; // pay or disc

                    if(value.payment != null){
                        if(value.payment.payment_allocate != null){
                            arrayDescriptionContainer = value.payment.payment_allocate
                        }

                        if (value.payment.claim != null) {
                            arrayClaimDetail = value.payment.claim.claim_detail
                        }

                        isCategory = value.payment.category
                    }

                    if (isCategory == 'disc') {
                        _.forEach(arrayClaimDetail, function(claim) {
                            description += '<br/> - ' + claim.description
                        })
                    } else {
                        _.forEach(arrayDescriptionContainer, function(paymentAllocate) {
                            if(paymentAllocate.invoice_due != null){
                                description += '<br/>- '+paymentAllocate.invoice_due.receivable.description
                            } else {
                                description += '<br/><font style="color:red">- NOT_FOUND </font>'

                                var errorMessage = 'Transaksi tgl ' + parent.showDateFormatted(value.transactionDate) + ' ada Invoice yang berubah';

                                parent.$Notice.warning({
                                    title: "Perhatian",
                                    desc: errorMessage,
                                    duration: 0
                                });

                            }
                        })
                    }

                    let category = ''
                    let claim = ''
                    let giro = ''

                    if(value.payment) {
                      category = value.payment.category
                      claim = value.payment.claim
                      giro = value.payment.giro
                    }

                    let depositAmount = 0;
                    if(value.type == 'DEP') {
                       depositAmount = value.debitAmount == 0 ? numeral(-value.creditAmount).format('0,0') : numeral(value.debitAmount).format('0,0') ;
                    }

                    let createdby = "<br/><i>"+ value.createdby + "</i>"
                    let receivable = {
                        transactionDate : parent.showDateFormatted(value.transactionDate) + createdby,
                        markingHeaderId : value.markingHeaderId,
                        invoicefee : numeral(invoicefee).format('0,0'),
                        isSettled : isSettled,
                        markingheadercode : value.marking_header.markingheadercode,
                        description : description,
                        debitAmount : numeral(debitAmount).format('0,0'),
                        creditAmount : numeral(value.creditAmount).format('0,0'),
                        depositAmount : depositAmount,
                        balanceWithoutDeposit : numeral(countBalanceWithoutDeposit).format('0,0'),
                        balance : numeral(countBalance).format('0,0'),
                        category : category,
                        type : value.type,
                        claimId : value.claimId,
                        claim : claim,
                        giro : giro,
                        payment : value.payment
                    }

                    receivables.push(receivable);
                });
                this.receivables =  receivables;
                this.loadingGetReceivable = false;

                parent.depositRemaining = depositRemainingRes.data.remaining
                parent.countBalance = countBalance

            }))
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            });

        },

        getMarkingByCode: _.debounce(
            function (query) {

                if (query !== '') {
                    this.loadingGetMarking = true;
                    HTTP
                    // .post('marking/getByCodeAll', {
                    .post('marking/getBySnapshot', {
                        markingHeaderId: query,
                        subbranchcode: this.subbranchcode
                    })
                    .then(response => {

                        this.invoiceDues = []
                        this.amountResidue = ''
                        this.amountReceived = ''
                        this.description = ''

                        this.loadingGetMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.markingheaderid,
                                label: item.markingheadercode
                            };
                        });

                        this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.loadingGetMarking = false;
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];


                }
            }, 400
        ),

        showDateFormatted : function(stringToFormat){
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        isSettled : function (invoice){
            if(invoice != null){
                if(invoice.settledDate != null){
                        return true;
                }
            }

            return false;
        }
    },
    filters: {
        currency: function (value) {
        if (!value) return ''
        return numeral(value).format('0,0')
        }
    } ,
  created() {
    //this.getReceivable();
    this.user.username = localStorage.getItem('user.username')
    this.user.role = localStorage.getItem('user.role')
  }
}

</script>



// WEBPACK FOOTER //
// ReceivableListDetail.vue?77f68aa6